"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _nuiLogger = require("@concur/nui-logger");
var _fetchRetry = _interopRequireDefault(require("./fetch-retry"));
var _logger = _interopRequireDefault(require("./logger"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line no-unused-vars
var regeneratorRuntime = require('regenerator-runtime');
var callApigwSetCookie = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(JWT, sessionId, apigwUrl) {
    var response, responseText, OTSESSIONAABQRD;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            responseText = '';
            OTSESSIONAABQRD = sessionId === null || sessionId === void 0 ? void 0 : sessionId.toUpperCase().replace(/-/g, 'G');
            if (apigwUrl.startsWith('http://')) {
              apigwUrl = apigwUrl.replace('http://', 'https://');
            }
            _context.prev = 3;
            _context.next = 6;
            return (0, _fetchRetry.default)("".concat(apigwUrl, "/set-cookie"), {
              method: 'get',
              redirect: 'manual',
              timeout: 5000,
              retries: 2,
              retryOn: [500, 504],
              retryDelay: 500,
              credentials: 'include',
              headers: {
                'Authorization': "Bearer ".concat(JWT),
                'X-OTSESSIONAABQRD': "".concat(OTSESSIONAABQRD)
              }
            });
          case 6:
            response = _context.sent;
            _context.next = 9;
            return response.text();
          case 9:
            responseText = _context.sent;
            if (!(response.status === 200)) {
              _context.next = 14;
              break;
            }
            return _context.abrupt("return", responseText);
          case 14:
            throw responseText;
          case 15:
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);
            throw new _nuiLogger.CategorizedError(_context.t0, {
              cause: _objectSpread({
                responseText: responseText
              }, response),
              category: 'nui-auth-api',
              subcategory: 'apigw-set-cookie-failure'
            });
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 17]]);
  }));
  return function callApigwSetCookie(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _default = exports.default = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(JWT, sessionId, apigwUrl, apigwBrowserUrl) {
    var apiCookieResponse;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return callApigwSetCookie(JWT, sessionId, apigwBrowserUrl);
          case 3:
            apiCookieResponse = _context2.sent;
            _logger.default.info({
              description: "success setting www-api cookies: ".concat(apiCookieResponse),
              category: 'nui-auth-client',
              subcategory: 'api-cookie-jwt-refresh-set-success'
            });
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            _logger.default.info({
              description: "error setting www-api cookies: ".concat(_context2.t0),
              category: 'nui-auth-client',
              subcategory: 'api-cookie-jwt-refresh-set-failure'
            });
          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return function (_x4, _x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();